import { Component, Input, EventEmitter, Output} from '@angular/core';

/**
   * Logger Factory
   * @namespace title: tile to show
   * @namespace date: is the date to show
   * <ute-avatar class="image"  image="..." isEditable="true"></ute-avatar>
*/
@Component({
  selector: 'ute-action-card',
  templateUrl: 'ute-action-card.component.html',
})
export class UteActionCard {
  @Input() icon: string;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() button: string;
  @Output() buttonClick = new EventEmitter;

  constructor() {
  }
  
  onButtonClick(event) {
    this.buttonClick.emit(event);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-action-card/ute-action-card.component.ts